import { Link } from "react-router-dom";
import { Calendar, Clock, Video, ArrowRight } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

const BookingPreview = () => {
    const { t } = useLanguage();
    const P = t.previews.booking;

    return (
        <section
            id="booking-preview"
            data-testid="booking-preview-section"
            className="py-24 md:py-28 bg-gradient-to-b from-ella-cream to-ella-sand"
        >
            <div className="ella-container">
                <div className="relative max-w-4xl mx-auto rounded-[2rem] border border-ella-line bg-white/80 backdrop-blur p-10 md:p-14 overflow-hidden">
                    <div className="absolute -top-20 -right-20 w-64 h-64 rounded-full bg-[radial-gradient(circle_at_center,rgba(193,154,107,0.18),transparent_60%)] pointer-events-none" />

                    <div className="relative grid md:grid-cols-2 gap-10 items-center">
                        <div>
                            <span className="ella-overline" data-testid="booking-preview-overline">
                                {P.overline}
                            </span>
                            <h2
                                className="ella-headline text-3xl md:text-4xl lg:text-5xl mt-4 text-ella-ink leading-tight"
                                data-testid="booking-preview-title"
                            >
                                {P.title}
                            </h2>
                            <p className="mt-5 text-ella-ink/70 font-light text-base leading-relaxed max-w-md">
                                {P.lead}
                            </p>

                            <Link
                                to="/kennenlerngespraech"
                                data-testid="booking-preview-cta"
                                className="inline-flex items-center gap-3 mt-8 px-7 py-3.5 rounded-full bg-ella-gold text-ella-onyx hover:bg-ella-gold-dark hover:text-ella-cream transition-colors text-xs uppercase tracking-[0.24em]"
                            >
                                <Calendar className="w-4 h-4" strokeWidth={1.5} />
                                {P.cta}
                                <ArrowRight className="w-4 h-4" strokeWidth={1.5} />
                            </Link>
                        </div>

                        <ul className="space-y-5">
                            <li className="flex items-start gap-4">
                                <span className="w-10 h-10 rounded-full bg-ella-blush/50 flex items-center justify-center text-ella-rose-dark flex-shrink-0">
                                    <Clock className="w-4 h-4" strokeWidth={1.5} />
                                </span>
                                <div>
                                    <p className="ella-overline">{t.booking.duration_label}</p>
                                    <p className="font-serif text-lg text-ella-ink mt-0.5">
                                        {t.booking.duration}
                                    </p>
                                </div>
                            </li>
                            <li className="flex items-start gap-4">
                                <span className="w-10 h-10 rounded-full bg-ella-blush/50 flex items-center justify-center text-ella-rose-dark flex-shrink-0">
                                    <Video className="w-4 h-4" strokeWidth={1.5} />
                                </span>
                                <div>
                                    <p className="ella-overline">{t.booking.type_label}</p>
                                    <p className="font-serif text-lg text-ella-ink mt-0.5">
                                        {t.booking.type}
                                    </p>
                                </div>
                            </li>
                            <li className="flex items-start gap-4">
                                <span className="w-10 h-10 rounded-full bg-ella-blush/50 flex items-center justify-center text-ella-rose-dark flex-shrink-0">
                                    <Calendar className="w-4 h-4" strokeWidth={1.5} />
                                </span>
                                <div>
                                    <p className="ella-overline">{t.booking.cost_label}</p>
                                    <p className="font-serif text-lg text-ella-ink mt-0.5">
                                        {t.booking.cost}
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BookingPreview;
